<div class="h-full flex flex-col justify-between">
  <div class="h-full">
    <h1 class="text-2xl font-semibold text-neutral-900 mb-2xl">
      {{ 'workflow_permissions_list_screen_title' | transloco }}
    </h1>

    <div
      class="py-lg flex justify-between items-center border-b border-neutral-200">
      <div class="flex items-center gap-lg">
        <h5 class="text-lg font-semibold text-neutral-900">
          {{ 'workflow_permissions_list_screen_sub_title' | transloco }}
        </h5>

        <lib-badge
          [label]="ownersCount()"
          [badgeClass]="
            'px-sm border-none text-sm font-medium bg-primary-50 text-primary-700'
          " />
      </div>
    </div>

    <div class="table-section">
      <lib-table
        [tableClass]="
          'min-h-[calc(100vh-35.5rem)] h-full w-full whitespace-nowrap'
        "
        [id]="'workflow_permission_table'"
        [dataSource]="permissionList()"
        [loading]="isLoading()"
        [columns]="columns"
        [noDataTitle]="'table_no_data_title' | transloco"
        [noDataDescription]="'section_no_data_description' | transloco"
        [bodyTemplateRef]="[number, type_name, type_owner, action]"
        [tableFilterTabs]="tableFilterTabs"
        [titleBottomBorder]="false"
        [lastColumnAlignment]="'justify-end'"
        (handleViewIconClick)="viewCategoryDetails($event)">
        <ng-template #number let-row let-i="i">
          {{ (currentPage() - 1) * currentSize() + (i + 1) }}
        </ng-template>

        <ng-template #number let-row let-i="i">
          {{ (currentPage() - 1) * currentSize() + (i + 1) }}
        </ng-template>

        <ng-template #type_name let-row>
          <h5 class="text-xs text-neutral-900 font-medium">
            {{ row.name }}
          </h5>
        </ng-template>

        <ng-template #type_owner let-row>
          @if (row.owners.length) {
            <lib-user-dropdown-view
              [userCount]="row.owners_count"
              [userTableList]="row.owners"
              [userDropdownList]="ownerDropdownList()"
              [isDropdownLoading]="isOwnerLoading()"
              [currentDropdownPage]="currentOwnerPage()"
              [totalDropdownPages]="totalOwnerPages()"
              [totalDropdownCount]="totalOwnerCount()"
              [containerRef]="'workflow_permission_table'"
              [searchLabel]="'dropdown_search_find_users_label' | transloco"
              [searchPlaceholder]="'search_by_name_placeholder' | transloco"
              [headerListLabel]="
                'dropdown_header_list_owners_label' | transloco
              "
              [noSearchResultLabel]="'no_search_result_label' | transloco"
              (handleMenuToggle)="getWorkflowOwnerDropdown($event, row.id)" />
          }
        </ng-template>

        <ng-template #action let-row>
          <lib-action-list
            [parentName]="'workflow_permission_table'"
            [menuItems]="getActionMenuItems(row.id)"
            (itemClick)="actionListItemClick($event, row.id)" />
        </ng-template>
      </lib-table>

      @if (permissionList().length) {
        <div class="py-2xl">
          <lib-paginator
            [sizeOptionsLabel]="
              'pagination_number_of_rows_per_page_label' | transloco
            "
            [nextBtnLabel]="'pagination_next_button_label' | transloco"
            [previousBtnLabel]="'pagination_previous_button_label' | transloco"
            [currentPage]="currentPage()"
            [totalPages]="totalPages()"
            [totalItems]="+ownersCount()"
            [showChangeSize]="true"
            [sizeOptions]="pageSizeOptions"
            (goTo)="handlePagination($event)"
            (next)="handlePagination($event)"
            (previous)="handlePagination($event)"
            (handleChangeSize)="changeSize($event)"
            [currentSize]="currentSize()" />
        </div>
      }
    </div>
  </div>
</div>

<ng-template #assignOwnersDialog>
  <lib-assign-group-users
    [groupUsersCards]="groupUsersCards()"
    [selectedGroupUsersCards]="selectedUsers()"
    (unselectGroupUser)="removeSelectedGroupUser($event)"
    (selectGroupUser)="onSelectGroupUser($event)"
    (filterGroupUsersCards)="getUsers($event)"
    (paginateGroupUsersCards)="getUsers('', $event)"
    (saveAssignedGroupUsers)="onSubmitAssignedGroupUsers()"
    [isLoading]="isLoadingGroupUsers()"
    [currentPage]="modalCurrentPage()"
    [totalPages]="modalTotalPages()"
    [itemType]="'User'"
    [isSubmitLoading]="isAssignOwnersLoading()"
    (cancelModal)="clearSelectedUsers()" />
</ng-template>
